import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { UserService } from '../../shared/services/user.service';
import { forkJoin } from 'rxjs';
import { Utilities } from '../../shared/utilities';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.css']
})

export class ForgotPasswordFormComponent implements OnInit, OnDestroy {
  @Input() isInPopup = false;
  @Output() changeScreen: EventEmitter<any> = new EventEmitter<any>();
  public processing = false;

  public formData = {
    email: '',
    error: '',
    message: ''
  };

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Si un usuario logueado entra al la recuperación de password por URL, cierro sesión (vuelve a la home).
    if (!this.isInPopup && this.authenticationService.userIsLoggedIn()) {
      this.authenticationService.logout();
    }
  }

  ngOnDestroy(): void {
  }

  public recoverPassword(): void {
    const that = this;
    if (!that.processing) {
      that.processing = true;
      if (that.validateData()) {
        forkJoin([
          that.userService.recoverPasswordStep1(that.formData.email)
        ]).subscribe(([recoverPasswordStep1Response]) => {
            if (recoverPasswordStep1Response) {
              if (!recoverPasswordStep1Response.HasError) {
                that.resetFormData();
                that.formData.message = '<p><b>Se le ha enviado un correo con los pasos a seguir.</b></p>';
              } else {
                if (recoverPasswordStep1Response.ErrorMessage){
                  that.formData.error = `<p><b>¡Error!</b></p><p>${recoverPasswordStep1Response.ErrorMessage}</p>`;
                } else {
                  that.formData.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
                }
              }
            } else {
              that.formData.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
            }
            that.processing = false;
          },
          (error) => {
            Utilities.logError('Error al solicitar la recuperación de password');
            Utilities.logError(error);
            that.processing = false;
            localStorage.clear();
            that.formData.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
          });
      } else {
        that.processing = false;
      }
    }
  }

  public validateData(): boolean {
    const that = this;
    that.formData.error = '';
    that.formData.message = '';
    let dataIsValid = true;
    if (
      that.formData.email &&
      that.formData.email.trim().length > 0
    ) {
      that.formData.email = that.formData.email.trim();
      if (!that.formData.email.trim().match(Utilities.EXP_REG_FORMATO_EMAIL)) {
        dataIsValid = false;
        that.formData.error = '<p><b>Verifique los datos.</b></p><p>El email no tiene un formato válido.</p>';
      }
    } else {
      dataIsValid = false;
      that.formData.error = '<p><b>Complete el formulario.</b></p><p>El email es obligatorio.</p>';
    }
    return dataIsValid;
  }

  private resetFormData(): void {
    this.formData = {
      email: '',
      error: '',
      message: ''
    };
  }

  public goToLogin(): void {
    if (this.isInPopup) {
      this.changeScreen.emit({screen: 'SIGN_IN'});
    } else {
      this.goTo('ingreso');
    }
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }
}
